/* eslint-disable typescript-enum/no-enum */

/**
 * User account preferences.
 */
export enum EUserPreference {
  // Current context preferences:
  ONBOARDING_RTMP = 'rtmpobtp',
  ONBOARDING_RTC = 'slobtp',
  ONBOARDING_RTC_BOKEH = 'slnwbrdnbh',
  ONBOARDING_RTC_SIMULIVE = 'sltrschld',
  PUBLISH_TO_SOCIAL = 'psaa',
  // Owner context preferences:
  EXTENDED_STREAM_WITH_DVR = 'ldful',
  EXTENDED_STREAM_WITH_SIMULCAST = 'lsful',
}

/**
 * User account entitlements.
 */
export enum EUserEntitlement {
  LIVE_GUEST_API_MANAGEMENT = 'liveGuestApiManagement',
  LIVE_MEDIA_API_MANAGEMENT = 'liveMediaApiManagement',
  LIVE_COMPOSER_TEMPLATES_ACCESS = 'liveComposerTemplatesAccess',
}
